import { jsx as _jsx } from "react/jsx-runtime";
import { PageTypeEnum } from '../enums/page-type-enum';
import { DigitalProductCheckoutApp, } from './digital-product-checkout-app';
import { HomeApp } from './home-app';
import { PhysicalProductCheckoutApp, } from './physical-product-checkout-app';
import { ThankYouApp } from './thank-you-app';
export function App({ pageWithProviders, pageType }) {
    switch (pageType) {
        case PageTypeEnum.home_page:
            return _jsx(HomeApp, { pageWithProviders: pageWithProviders });
        case PageTypeEnum.checkout_page:
            if (pageWithProviders.checkoutPage.digitalProductId) {
                return _jsx(DigitalProductCheckoutApp, { pageWithProviders: pageWithProviders });
            }
            if (pageWithProviders.checkoutPage.physicalProductId) {
                return _jsx(PhysicalProductCheckoutApp, { pageWithProviders: pageWithProviders });
            }
            break;
        case PageTypeEnum.thank_you_page:
            return _jsx(ThankYouApp, { pageWithProviders: pageWithProviders });
    }
}
